/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  DashboardCreateLeague,
  DashboardLeagueAthleteList,
  DashboardLeagueDetail,
  DashboardLeagueList,
  DashboardLeagueListItem,
  DashboardLeagueOnboardingStep,
  DashboardLeagueOnboardingUpdate,
  DashboardLeagueOrganizerRef,
  DashboardLeagueOrganizerSearchOutput,
  DashboardLeagueOverview,
  DashboardLeagueSearchResult,
  DashboardLeagueTeamList,
  DashboardLeagueTeamMembers,
  DashboardLeagueTopAthleteList,
  DashboardLeagueTopTeamList,
  DashboardLeaguesControllerAthletes400,
  DashboardLeaguesControllerAthletes401,
  DashboardLeaguesControllerAthletes404,
  DashboardLeaguesControllerAthletes429,
  DashboardLeaguesControllerAthletesExport400,
  DashboardLeaguesControllerAthletesExport401,
  DashboardLeaguesControllerAthletesExport404,
  DashboardLeaguesControllerAthletesExport413,
  DashboardLeaguesControllerAthletesExport429,
  DashboardLeaguesControllerAthletesExportParams,
  DashboardLeaguesControllerAthletesParams,
  DashboardLeaguesControllerCreate400,
  DashboardLeaguesControllerCreate401,
  DashboardLeaguesControllerCreate403,
  DashboardLeaguesControllerCreate429,
  DashboardLeaguesControllerDetail400,
  DashboardLeaguesControllerDetail401,
  DashboardLeaguesControllerDetail404,
  DashboardLeaguesControllerDetail429,
  DashboardLeaguesControllerExport400,
  DashboardLeaguesControllerExport401,
  DashboardLeaguesControllerExport413,
  DashboardLeaguesControllerExport429,
  DashboardLeaguesControllerExportParams,
  DashboardLeaguesControllerList400,
  DashboardLeaguesControllerList401,
  DashboardLeaguesControllerList429,
  DashboardLeaguesControllerListParams,
  DashboardLeaguesControllerOnboarding400,
  DashboardLeaguesControllerOnboarding401,
  DashboardLeaguesControllerOnboarding403,
  DashboardLeaguesControllerOnboarding404,
  DashboardLeaguesControllerOnboarding429,
  DashboardLeaguesControllerOrganizerRefs400,
  DashboardLeaguesControllerOrganizerRefs401,
  DashboardLeaguesControllerOrganizerRefs429,
  DashboardLeaguesControllerOrganizerRefsParams,
  DashboardLeaguesControllerOverview400,
  DashboardLeaguesControllerOverview401,
  DashboardLeaguesControllerOverview404,
  DashboardLeaguesControllerOverview429,
  DashboardLeaguesControllerRefs400,
  DashboardLeaguesControllerRefs401,
  DashboardLeaguesControllerRefs429,
  DashboardLeaguesControllerRefsParams,
  DashboardLeaguesControllerReorder400,
  DashboardLeaguesControllerReorder401,
  DashboardLeaguesControllerReorder403,
  DashboardLeaguesControllerReorder429,
  DashboardLeaguesControllerSearch400,
  DashboardLeaguesControllerSearch401,
  DashboardLeaguesControllerSearch429,
  DashboardLeaguesControllerSearchOrganizers400,
  DashboardLeaguesControllerSearchOrganizers401,
  DashboardLeaguesControllerSearchOrganizers429,
  DashboardLeaguesControllerSearchOrganizersParams,
  DashboardLeaguesControllerSearchParams,
  DashboardLeaguesControllerSkipAllOnboarding400,
  DashboardLeaguesControllerSkipAllOnboarding401,
  DashboardLeaguesControllerSkipAllOnboarding403,
  DashboardLeaguesControllerSkipAllOnboarding404,
  DashboardLeaguesControllerSkipAllOnboarding429,
  DashboardLeaguesControllerSports400,
  DashboardLeaguesControllerSports401,
  DashboardLeaguesControllerSports404,
  DashboardLeaguesControllerSports429,
  DashboardLeaguesControllerTeamMembers400,
  DashboardLeaguesControllerTeamMembers401,
  DashboardLeaguesControllerTeamMembers404,
  DashboardLeaguesControllerTeamMembers429,
  DashboardLeaguesControllerTeams400,
  DashboardLeaguesControllerTeams401,
  DashboardLeaguesControllerTeams404,
  DashboardLeaguesControllerTeams429,
  DashboardLeaguesControllerTeamsExport400,
  DashboardLeaguesControllerTeamsExport401,
  DashboardLeaguesControllerTeamsExport404,
  DashboardLeaguesControllerTeamsExport413,
  DashboardLeaguesControllerTeamsExport429,
  DashboardLeaguesControllerTeamsExportParams,
  DashboardLeaguesControllerTeamsParams,
  DashboardLeaguesControllerTopAthletes400,
  DashboardLeaguesControllerTopAthletes401,
  DashboardLeaguesControllerTopAthletes404,
  DashboardLeaguesControllerTopAthletes429,
  DashboardLeaguesControllerTopAthletesParams,
  DashboardLeaguesControllerTopTeams400,
  DashboardLeaguesControllerTopTeams401,
  DashboardLeaguesControllerTopTeams404,
  DashboardLeaguesControllerTopTeams429,
  DashboardLeaguesControllerTopTeamsParams,
  DashboardLeaguesControllerUpdate400,
  DashboardLeaguesControllerUpdate401,
  DashboardLeaguesControllerUpdate403,
  DashboardLeaguesControllerUpdate404,
  DashboardLeaguesControllerUpdate409,
  DashboardLeaguesControllerUpdate429,
  DashboardLeaguesControllerUpdateOnboardingStep400,
  DashboardLeaguesControllerUpdateOnboardingStep401,
  DashboardLeaguesControllerUpdateOnboardingStep403,
  DashboardLeaguesControllerUpdateOnboardingStep404,
  DashboardLeaguesControllerUpdateOnboardingStep429,
  DashboardReorderLeagues,
  DashboardReorderLeaguesInput,
  DashboardSportRef,
  DashboardUpdateLeague,
  LeagueRef,
} from ".././schemas";
import { restClient } from "../../restClient";
import type { ErrorType, BodyType } from "../../restClient";

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Paginated league list scoped to the caller: the `LEAGUE:READ` RBAC capability universe (full-platform / full-federation / pair grants, connected-platform pairs, and league-level grants). `platformIds` and `federationIds` are pure filters applied together (AND); the platform filter reads the authoritative league platform attribution (unattributed leagues fall back to every platform their owner federation is linked to). Requesting an out-of-scope platform / federation narrows the result — possibly to an empty page — instead of a 403. Filters: keyword, platform / federation / sport ids, ISO country codes, lifecycle status, league/tour type (`tourTypes` — multiselect, any-of), tournaments-count range. Each row carries identity, geo scope, league/tour type, status, country, logo, contact (email / website — for export), the single bound sport, accessible platforms, the owning federation ref, and the denormalized tournaments count.

Each row also carries `capabilities` — the league-directed (`LEAGUE` resource) RBAC capability keys the caller holds on that league's LEAGUE node — so the FE can gate per-row Edit / Delete controls without a follow-up request.
 * @summary List leagues (dashboard)
 */
export const dashboardLeaguesControllerList = (
  params?: DashboardLeaguesControllerListParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLeagueList>(
    { url: `/api/dashboard/v1/leagues`, method: "GET", params, signal },
    options
  );
};

export const getDashboardLeaguesControllerListQueryKey = (
  params?: DashboardLeaguesControllerListParams
) => {
  return [`/api/dashboard/v1/leagues`, ...(params ? [params] : [])] as const;
};

export const getDashboardLeaguesControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerList>>,
  TError = ErrorType<
    | DashboardLeaguesControllerList400
    | DashboardLeaguesControllerList401
    | DashboardLeaguesControllerList429
  >,
>(
  params?: DashboardLeaguesControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardLeaguesControllerListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardLeaguesControllerList>>> = ({
    signal,
  }) => dashboardLeaguesControllerList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeaguesControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeaguesControllerList>>
>;
export type DashboardLeaguesControllerListQueryError = ErrorType<
  | DashboardLeaguesControllerList400
  | DashboardLeaguesControllerList401
  | DashboardLeaguesControllerList429
>;

export function useDashboardLeaguesControllerList<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerList>>,
  TError = ErrorType<
    | DashboardLeaguesControllerList400
    | DashboardLeaguesControllerList401
    | DashboardLeaguesControllerList429
  >,
>(
  params: undefined | DashboardLeaguesControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerList<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerList>>,
  TError = ErrorType<
    | DashboardLeaguesControllerList400
    | DashboardLeaguesControllerList401
    | DashboardLeaguesControllerList429
  >,
>(
  params?: DashboardLeaguesControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerList<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerList>>,
  TError = ErrorType<
    | DashboardLeaguesControllerList400
    | DashboardLeaguesControllerList401
    | DashboardLeaguesControllerList429
  >,
>(
  params?: DashboardLeaguesControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List leagues (dashboard)
 */

export function useDashboardLeaguesControllerList<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerList>>,
  TError = ErrorType<
    | DashboardLeaguesControllerList400
    | DashboardLeaguesControllerList401
    | DashboardLeaguesControllerList429
  >,
>(
  params?: DashboardLeaguesControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerList>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeaguesControllerListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new league (a.k.a. a "tour" — the same entity, discriminated by `tourType`). Anchored to a `platformId` and/or an owning `federationId` (`fed_…`, persisted as a `league_owner` row): at least one is required and the caller must have access to whichever is supplied. `clubIds` optionally connects the league to clubs for Manager display only; every club requires `CLUB:WRITE` and the association grants no permissions. Uploaded assets are passed as storage file ids (`logoFileId` / `bannerCoverFileId` / `abbreviationLogoFileId`). Returns the created row in the same shape as `GET /api/dashboard/v1/leagues` so the FE can prepend it to the table without a re-fetch.
 * @summary Create league (dashboard)
 */
export const dashboardLeaguesControllerCreate = (
  dashboardCreateLeague: BodyType<DashboardCreateLeague>,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLeagueListItem>(
    {
      url: `/api/dashboard/v1/leagues`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dashboardCreateLeague,
      signal,
    },
    options
  );
};

export const getDashboardLeaguesControllerCreateMutationOptions = <
  TError = ErrorType<
    | DashboardLeaguesControllerCreate400
    | DashboardLeaguesControllerCreate401
    | DashboardLeaguesControllerCreate403
    | DashboardLeaguesControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreateLeague> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeaguesControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreateLeague> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeaguesControllerCreate>>,
    { data: BodyType<DashboardCreateLeague> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardLeaguesControllerCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeaguesControllerCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeaguesControllerCreate>>
>;
export type DashboardLeaguesControllerCreateMutationBody = BodyType<DashboardCreateLeague>;
export type DashboardLeaguesControllerCreateMutationError = ErrorType<
  | DashboardLeaguesControllerCreate400
  | DashboardLeaguesControllerCreate401
  | DashboardLeaguesControllerCreate403
  | DashboardLeaguesControllerCreate429
>;

/**
 * @summary Create league (dashboard)
 */
export const useDashboardLeaguesControllerCreate = <
  TError = ErrorType<
    | DashboardLeaguesControllerCreate400
    | DashboardLeaguesControllerCreate401
    | DashboardLeaguesControllerCreate403
    | DashboardLeaguesControllerCreate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerCreate>>,
    TError,
    { data: BodyType<DashboardCreateLeague> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeaguesControllerCreate>>,
  TError,
  { data: BodyType<DashboardCreateLeague> },
  TContext
> => {
  const mutationOptions = getDashboardLeaguesControllerCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Batched id → ref lookup for filter-chip rehydration. Ids the caller cannot reach (different federation) are dropped silently from the response.

With `withCapabilities=true`, each ref additionally carries `capabilities` — the full RBAC capability set the caller holds on that league's LEAGUE node — so `CurrentLeagueContext` can gate league-scoped surfaces without a second fetch. Omitted by default so slim picker / chip consumers skip the RBAC lookup.
 * @summary Resolve league ids to slim refs (dashboard)
 */
export const dashboardLeaguesControllerRefs = (
  params: DashboardLeaguesControllerRefsParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<LeagueRef[]>(
    { url: `/api/dashboard/v1/leagues/refs`, method: "GET", params, signal },
    options
  );
};

export const getDashboardLeaguesControllerRefsQueryKey = (
  params: DashboardLeaguesControllerRefsParams
) => {
  return [`/api/dashboard/v1/leagues/refs`, ...(params ? [params] : [])] as const;
};

export const getDashboardLeaguesControllerRefsQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerRefs>>,
  TError = ErrorType<
    | DashboardLeaguesControllerRefs400
    | DashboardLeaguesControllerRefs401
    | DashboardLeaguesControllerRefs429
  >,
>(
  params: DashboardLeaguesControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerRefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardLeaguesControllerRefsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardLeaguesControllerRefs>>> = ({
    signal,
  }) => dashboardLeaguesControllerRefs(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerRefs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeaguesControllerRefsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeaguesControllerRefs>>
>;
export type DashboardLeaguesControllerRefsQueryError = ErrorType<
  | DashboardLeaguesControllerRefs400
  | DashboardLeaguesControllerRefs401
  | DashboardLeaguesControllerRefs429
>;

export function useDashboardLeaguesControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerRefs>>,
  TError = ErrorType<
    | DashboardLeaguesControllerRefs400
    | DashboardLeaguesControllerRefs401
    | DashboardLeaguesControllerRefs429
  >,
>(
  params: DashboardLeaguesControllerRefsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerRefs>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerRefs>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerRefs>>,
  TError = ErrorType<
    | DashboardLeaguesControllerRefs400
    | DashboardLeaguesControllerRefs401
    | DashboardLeaguesControllerRefs429
  >,
>(
  params: DashboardLeaguesControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerRefs>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerRefs>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerRefs>>,
  TError = ErrorType<
    | DashboardLeaguesControllerRefs400
    | DashboardLeaguesControllerRefs401
    | DashboardLeaguesControllerRefs429
  >,
>(
  params: DashboardLeaguesControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerRefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Resolve league ids to slim refs (dashboard)
 */

export function useDashboardLeaguesControllerRefs<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerRefs>>,
  TError = ErrorType<
    | DashboardLeaguesControllerRefs400
    | DashboardLeaguesControllerRefs401
    | DashboardLeaguesControllerRefs429
  >,
>(
  params: DashboardLeaguesControllerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerRefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeaguesControllerRefsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Paginated keyword search across `title` for the dashboard league async-multi-select. Bounded by `limit` (max 50) and the caller's RBAC capability scope. Optional `capabilities` narrows the options server-side to leagues the caller may act on with at least one of the supplied capability keys (union); when absent the options default to the caller's `LEAGUE:READ` universe — the same scope `GET /leagues` applies. Optional `hasTournamentCategories=true` restricts results to leagues that have at least one tournament category (index-friendly EXISTS semi-join). Returns slim refs (`id`, `title`, `logo`) wrapped in the standard pagination envelope so the FE can drive an infinite-scroll dropdown.
 * @summary League typeahead search (dashboard)
 */
export const dashboardLeaguesControllerSearch = (
  params?: DashboardLeaguesControllerSearchParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLeagueSearchResult>(
    { url: `/api/dashboard/v1/leagues/search`, method: "GET", params, signal },
    options
  );
};

export const getDashboardLeaguesControllerSearchQueryKey = (
  params?: DashboardLeaguesControllerSearchParams
) => {
  return [`/api/dashboard/v1/leagues/search`, ...(params ? [params] : [])] as const;
};

export const getDashboardLeaguesControllerSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerSearch>>,
  TError = ErrorType<
    | DashboardLeaguesControllerSearch400
    | DashboardLeaguesControllerSearch401
    | DashboardLeaguesControllerSearch429
  >,
>(
  params?: DashboardLeaguesControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerSearch>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardLeaguesControllerSearchQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardLeaguesControllerSearch>>> = ({
    signal,
  }) => dashboardLeaguesControllerSearch(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerSearch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeaguesControllerSearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeaguesControllerSearch>>
>;
export type DashboardLeaguesControllerSearchQueryError = ErrorType<
  | DashboardLeaguesControllerSearch400
  | DashboardLeaguesControllerSearch401
  | DashboardLeaguesControllerSearch429
>;

export function useDashboardLeaguesControllerSearch<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerSearch>>,
  TError = ErrorType<
    | DashboardLeaguesControllerSearch400
    | DashboardLeaguesControllerSearch401
    | DashboardLeaguesControllerSearch429
  >,
>(
  params: undefined | DashboardLeaguesControllerSearchParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerSearch>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerSearch>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerSearch<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerSearch>>,
  TError = ErrorType<
    | DashboardLeaguesControllerSearch400
    | DashboardLeaguesControllerSearch401
    | DashboardLeaguesControllerSearch429
  >,
>(
  params?: DashboardLeaguesControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerSearch>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerSearch>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerSearch<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerSearch>>,
  TError = ErrorType<
    | DashboardLeaguesControllerSearch400
    | DashboardLeaguesControllerSearch401
    | DashboardLeaguesControllerSearch429
  >,
>(
  params?: DashboardLeaguesControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerSearch>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary League typeahead search (dashboard)
 */

export function useDashboardLeaguesControllerSearch<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerSearch>>,
  TError = ErrorType<
    | DashboardLeaguesControllerSearch400
    | DashboardLeaguesControllerSearch401
    | DashboardLeaguesControllerSearch429
  >,
>(
  params?: DashboardLeaguesControllerSearchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerSearch>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeaguesControllerSearchQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Paginated, autocomplete-friendly search over the DISTINCT organizers (league members) of ALL leagues the caller can see in the selected context. Scoped identically to `GET /leagues` (the `LEAGUE:READ` capability universe incl. league-level grants); `platformIds` / `federationIds` / `leagueIds` narrow within that scope, and an inaccessible requested scope narrows to an empty page instead of a 403. Unlike the tournaments-page organizer picker, this lists organizers of leagues regardless of whether they have tournaments. Each organizer carries `contactEmail` and `tournatedTag` alongside name / avatar / email.
 * @summary Search league organizers (dashboard)
 */
export const dashboardLeaguesControllerSearchOrganizers = (
  params?: DashboardLeaguesControllerSearchOrganizersParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLeagueOrganizerSearchOutput>(
    { url: `/api/dashboard/v1/leagues/organizers/search`, method: "GET", params, signal },
    options
  );
};

export const getDashboardLeaguesControllerSearchOrganizersQueryKey = (
  params?: DashboardLeaguesControllerSearchOrganizersParams
) => {
  return [`/api/dashboard/v1/leagues/organizers/search`, ...(params ? [params] : [])] as const;
};

export const getDashboardLeaguesControllerSearchOrganizersQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerSearchOrganizers>>,
  TError = ErrorType<
    | DashboardLeaguesControllerSearchOrganizers400
    | DashboardLeaguesControllerSearchOrganizers401
    | DashboardLeaguesControllerSearchOrganizers429
  >,
>(
  params?: DashboardLeaguesControllerSearchOrganizersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerSearchOrganizers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardLeaguesControllerSearchOrganizersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardLeaguesControllerSearchOrganizers>>
  > = ({ signal }) => dashboardLeaguesControllerSearchOrganizers(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerSearchOrganizers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeaguesControllerSearchOrganizersQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeaguesControllerSearchOrganizers>>
>;
export type DashboardLeaguesControllerSearchOrganizersQueryError = ErrorType<
  | DashboardLeaguesControllerSearchOrganizers400
  | DashboardLeaguesControllerSearchOrganizers401
  | DashboardLeaguesControllerSearchOrganizers429
>;

export function useDashboardLeaguesControllerSearchOrganizers<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerSearchOrganizers>>,
  TError = ErrorType<
    | DashboardLeaguesControllerSearchOrganizers400
    | DashboardLeaguesControllerSearchOrganizers401
    | DashboardLeaguesControllerSearchOrganizers429
  >,
>(
  params: undefined | DashboardLeaguesControllerSearchOrganizersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerSearchOrganizers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerSearchOrganizers>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerSearchOrganizers<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerSearchOrganizers>>,
  TError = ErrorType<
    | DashboardLeaguesControllerSearchOrganizers400
    | DashboardLeaguesControllerSearchOrganizers401
    | DashboardLeaguesControllerSearchOrganizers429
  >,
>(
  params?: DashboardLeaguesControllerSearchOrganizersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerSearchOrganizers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerSearchOrganizers>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerSearchOrganizers<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerSearchOrganizers>>,
  TError = ErrorType<
    | DashboardLeaguesControllerSearchOrganizers400
    | DashboardLeaguesControllerSearchOrganizers401
    | DashboardLeaguesControllerSearchOrganizers429
  >,
>(
  params?: DashboardLeaguesControllerSearchOrganizersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerSearchOrganizers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Search league organizers (dashboard)
 */

export function useDashboardLeaguesControllerSearchOrganizers<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerSearchOrganizers>>,
  TError = ErrorType<
    | DashboardLeaguesControllerSearchOrganizers400
    | DashboardLeaguesControllerSearchOrganizers401
    | DashboardLeaguesControllerSearchOrganizers429
  >,
>(
  params?: DashboardLeaguesControllerSearchOrganizersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerSearchOrganizers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeaguesControllerSearchOrganizersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Rehydrates URL-backed league-organizer filter chips, keeping only public ids (`usr_…`) that are a member of a league the caller can see in the requested `platformIds` / `federationIds` / `leagueIds` scope. Same capability scoping as the search endpoint.
 * @summary Resolve league organizer refs (dashboard)
 */
export const dashboardLeaguesControllerOrganizerRefs = (
  params: DashboardLeaguesControllerOrganizerRefsParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLeagueOrganizerRef[]>(
    { url: `/api/dashboard/v1/leagues/organizers/refs`, method: "GET", params, signal },
    options
  );
};

export const getDashboardLeaguesControllerOrganizerRefsQueryKey = (
  params: DashboardLeaguesControllerOrganizerRefsParams
) => {
  return [`/api/dashboard/v1/leagues/organizers/refs`, ...(params ? [params] : [])] as const;
};

export const getDashboardLeaguesControllerOrganizerRefsQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerOrganizerRefs>>,
  TError = ErrorType<
    | DashboardLeaguesControllerOrganizerRefs400
    | DashboardLeaguesControllerOrganizerRefs401
    | DashboardLeaguesControllerOrganizerRefs429
  >,
>(
  params: DashboardLeaguesControllerOrganizerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerOrganizerRefs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardLeaguesControllerOrganizerRefsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardLeaguesControllerOrganizerRefs>>
  > = ({ signal }) => dashboardLeaguesControllerOrganizerRefs(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerOrganizerRefs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeaguesControllerOrganizerRefsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeaguesControllerOrganizerRefs>>
>;
export type DashboardLeaguesControllerOrganizerRefsQueryError = ErrorType<
  | DashboardLeaguesControllerOrganizerRefs400
  | DashboardLeaguesControllerOrganizerRefs401
  | DashboardLeaguesControllerOrganizerRefs429
>;

export function useDashboardLeaguesControllerOrganizerRefs<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerOrganizerRefs>>,
  TError = ErrorType<
    | DashboardLeaguesControllerOrganizerRefs400
    | DashboardLeaguesControllerOrganizerRefs401
    | DashboardLeaguesControllerOrganizerRefs429
  >,
>(
  params: DashboardLeaguesControllerOrganizerRefsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerOrganizerRefs>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerOrganizerRefs>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerOrganizerRefs<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerOrganizerRefs>>,
  TError = ErrorType<
    | DashboardLeaguesControllerOrganizerRefs400
    | DashboardLeaguesControllerOrganizerRefs401
    | DashboardLeaguesControllerOrganizerRefs429
  >,
>(
  params: DashboardLeaguesControllerOrganizerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerOrganizerRefs>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerOrganizerRefs>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerOrganizerRefs<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerOrganizerRefs>>,
  TError = ErrorType<
    | DashboardLeaguesControllerOrganizerRefs400
    | DashboardLeaguesControllerOrganizerRefs401
    | DashboardLeaguesControllerOrganizerRefs429
  >,
>(
  params: DashboardLeaguesControllerOrganizerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerOrganizerRefs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Resolve league organizer refs (dashboard)
 */

export function useDashboardLeaguesControllerOrganizerRefs<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerOrganizerRefs>>,
  TError = ErrorType<
    | DashboardLeaguesControllerOrganizerRefs400
    | DashboardLeaguesControllerOrganizerRefs401
    | DashboardLeaguesControllerOrganizerRefs429
  >,
>(
  params: DashboardLeaguesControllerOrganizerRefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerOrganizerRefs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeaguesControllerOrganizerRefsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Streamed CSV / XLSX export of the full filtered set with parity against `GET /leagues`. No pagination; capped at 100k rows server-side (413 EXPORT_TOO_LARGE). Fixed column set — no dynamic columns. Empty scope yields a header-only file.
 * @summary Export leagues (dashboard)
 */
export const dashboardLeaguesControllerExport = (
  params: DashboardLeaguesControllerExportParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<Blob>(
    {
      url: `/api/dashboard/v1/leagues/export`,
      method: "GET",
      params,
      responseType: "blob",
      signal,
    },
    options
  );
};

export const getDashboardLeaguesControllerExportQueryKey = (
  params: DashboardLeaguesControllerExportParams
) => {
  return [`/api/dashboard/v1/leagues/export`, ...(params ? [params] : [])] as const;
};

export const getDashboardLeaguesControllerExportQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerExport>>,
  TError = ErrorType<
    | DashboardLeaguesControllerExport400
    | DashboardLeaguesControllerExport401
    | DashboardLeaguesControllerExport413
    | DashboardLeaguesControllerExport429
  >,
>(
  params: DashboardLeaguesControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerExport>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardLeaguesControllerExportQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardLeaguesControllerExport>>> = ({
    signal,
  }) => dashboardLeaguesControllerExport(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeaguesControllerExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeaguesControllerExport>>
>;
export type DashboardLeaguesControllerExportQueryError = ErrorType<
  | DashboardLeaguesControllerExport400
  | DashboardLeaguesControllerExport401
  | DashboardLeaguesControllerExport413
  | DashboardLeaguesControllerExport429
>;

export function useDashboardLeaguesControllerExport<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerExport>>,
  TError = ErrorType<
    | DashboardLeaguesControllerExport400
    | DashboardLeaguesControllerExport401
    | DashboardLeaguesControllerExport413
    | DashboardLeaguesControllerExport429
  >,
>(
  params: DashboardLeaguesControllerExportParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerExport>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerExport>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerExport<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerExport>>,
  TError = ErrorType<
    | DashboardLeaguesControllerExport400
    | DashboardLeaguesControllerExport401
    | DashboardLeaguesControllerExport413
    | DashboardLeaguesControllerExport429
  >,
>(
  params: DashboardLeaguesControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerExport>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerExport>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerExport<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerExport>>,
  TError = ErrorType<
    | DashboardLeaguesControllerExport400
    | DashboardLeaguesControllerExport401
    | DashboardLeaguesControllerExport413
    | DashboardLeaguesControllerExport429
  >,
>(
  params: DashboardLeaguesControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerExport>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Export leagues (dashboard)
 */

export function useDashboardLeaguesControllerExport<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerExport>>,
  TError = ErrorType<
    | DashboardLeaguesControllerExport400
    | DashboardLeaguesControllerExport401
    | DashboardLeaguesControllerExport413
    | DashboardLeaguesControllerExport429
  >,
>(
  params: DashboardLeaguesControllerExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerExport>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeaguesControllerExportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Persist a manual display order for the leagues in one scope — a platform (`scopeType=platform`, `scopeId=plt_…`) or a federation (`scopeType=federation`, `scopeId=fed_…`) — and one list tab (`tab`: `all` = the union, the default; `leagues` = `tourType=league`; `tours` = every non-league `tourType`). Each tab keeps its own independent order. `ids` must be the COMPLETE set of that scope's league publicIds (`lge_…`) within the selected tab, in the desired order — exactly the leagues `GET /leagues` returns for the same scope with the tab's `tourTypes` filter; a partial, extra or foreign set is a 400, because a partial reorder would silently corrupt the ordering of the leagues left out. The scope- and tab-specific stored order is rewritten to the array index inside one transaction, and becomes the default `SORTING_POSITION` order of the correspondingly filtered scoped list. Returns the persisted order.
 * @summary Reorder leagues within a scope (dashboard)
 */
export const dashboardLeaguesControllerReorder = (
  dashboardReorderLeaguesInput: BodyType<DashboardReorderLeaguesInput>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<DashboardReorderLeagues>(
    {
      url: `/api/dashboard/v1/leagues/reorder`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardReorderLeaguesInput,
    },
    options
  );
};

export const getDashboardLeaguesControllerReorderMutationOptions = <
  TError = ErrorType<
    | DashboardLeaguesControllerReorder400
    | DashboardLeaguesControllerReorder401
    | DashboardLeaguesControllerReorder403
    | DashboardLeaguesControllerReorder429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerReorder>>,
    TError,
    { data: BodyType<DashboardReorderLeaguesInput> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeaguesControllerReorder>>,
  TError,
  { data: BodyType<DashboardReorderLeaguesInput> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeaguesControllerReorder>>,
    { data: BodyType<DashboardReorderLeaguesInput> }
  > = (props) => {
    const { data } = props ?? {};

    return dashboardLeaguesControllerReorder(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeaguesControllerReorderMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeaguesControllerReorder>>
>;
export type DashboardLeaguesControllerReorderMutationBody = BodyType<DashboardReorderLeaguesInput>;
export type DashboardLeaguesControllerReorderMutationError = ErrorType<
  | DashboardLeaguesControllerReorder400
  | DashboardLeaguesControllerReorder401
  | DashboardLeaguesControllerReorder403
  | DashboardLeaguesControllerReorder429
>;

/**
 * @summary Reorder leagues within a scope (dashboard)
 */
export const useDashboardLeaguesControllerReorder = <
  TError = ErrorType<
    | DashboardLeaguesControllerReorder400
    | DashboardLeaguesControllerReorder401
    | DashboardLeaguesControllerReorder403
    | DashboardLeaguesControllerReorder429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerReorder>>,
    TError,
    { data: BodyType<DashboardReorderLeaguesInput> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeaguesControllerReorder>>,
  TError,
  { data: BodyType<DashboardReorderLeaguesInput> },
  TContext
> => {
  const mutationOptions = getDashboardLeaguesControllerReorderMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Aggregate payload for the dashboard league overview page, addressed by the league's `publicId` (`lge_…`). Returns the header fields, the athletes / managers counts, the slim refs of the platforms hosting the league, and bounded previews of the latest news, albums, and documents; album preview ids are opaque `alb_…` public ids and never numeric database keys. Tournament stats and the latest-tournaments list are fetched separately from the tournaments endpoints (both league-filterable). The `partners` section is capability-dependent: it is only populated for callers holding `LEAGUE_PARTNER:READ` on the league (the partners-surface gate); everyone else receives `[]` while the rest of the overview stays readable. 404 when the league does not exist or is outside the caller's scope.
 * @summary Get league overview (dashboard)
 */
export const dashboardLeaguesControllerOverview = (
  id: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLeagueOverview>(
    { url: `/api/dashboard/v1/leagues/${id}/overview`, method: "GET", signal },
    options
  );
};

export const getDashboardLeaguesControllerOverviewQueryKey = (id: string) => {
  return [`/api/dashboard/v1/leagues/${id}/overview`] as const;
};

export const getDashboardLeaguesControllerOverviewQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerOverview>>,
  TError = ErrorType<
    | DashboardLeaguesControllerOverview400
    | DashboardLeaguesControllerOverview401
    | DashboardLeaguesControllerOverview404
    | DashboardLeaguesControllerOverview429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerOverview>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardLeaguesControllerOverviewQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardLeaguesControllerOverview>>> = ({
    signal,
  }) => dashboardLeaguesControllerOverview(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerOverview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeaguesControllerOverviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeaguesControllerOverview>>
>;
export type DashboardLeaguesControllerOverviewQueryError = ErrorType<
  | DashboardLeaguesControllerOverview400
  | DashboardLeaguesControllerOverview401
  | DashboardLeaguesControllerOverview404
  | DashboardLeaguesControllerOverview429
>;

export function useDashboardLeaguesControllerOverview<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerOverview>>,
  TError = ErrorType<
    | DashboardLeaguesControllerOverview400
    | DashboardLeaguesControllerOverview401
    | DashboardLeaguesControllerOverview404
    | DashboardLeaguesControllerOverview429
  >,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerOverview>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerOverview>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerOverview<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerOverview>>,
  TError = ErrorType<
    | DashboardLeaguesControllerOverview400
    | DashboardLeaguesControllerOverview401
    | DashboardLeaguesControllerOverview404
    | DashboardLeaguesControllerOverview429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerOverview>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerOverview>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerOverview<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerOverview>>,
  TError = ErrorType<
    | DashboardLeaguesControllerOverview400
    | DashboardLeaguesControllerOverview401
    | DashboardLeaguesControllerOverview404
    | DashboardLeaguesControllerOverview429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerOverview>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get league overview (dashboard)
 */

export function useDashboardLeaguesControllerOverview<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerOverview>>,
  TError = ErrorType<
    | DashboardLeaguesControllerOverview400
    | DashboardLeaguesControllerOverview401
    | DashboardLeaguesControllerOverview404
    | DashboardLeaguesControllerOverview429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerOverview>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeaguesControllerOverviewQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Paginated list of the league's athletes (users with at least one confirmed tournament entry in the league), addressed by the league's `publicId` (`lge_…`). Filters: keyword (name / surname / email / Tournated tag), sport ids, gender, country. Each row carries the athlete's identity, sports, clubs, and the count of confirmed tournaments they've entered in this league. 404 when the league does not exist or is outside the caller's scope.
 * @summary List league athletes (dashboard)
 */
export const dashboardLeaguesControllerAthletes = (
  id: string,
  params?: DashboardLeaguesControllerAthletesParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLeagueAthleteList>(
    { url: `/api/dashboard/v1/leagues/${id}/athletes`, method: "GET", params, signal },
    options
  );
};

export const getDashboardLeaguesControllerAthletesQueryKey = (
  id: string,
  params?: DashboardLeaguesControllerAthletesParams
) => {
  return [`/api/dashboard/v1/leagues/${id}/athletes`, ...(params ? [params] : [])] as const;
};

export const getDashboardLeaguesControllerAthletesQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerAthletes>>,
  TError = ErrorType<
    | DashboardLeaguesControllerAthletes400
    | DashboardLeaguesControllerAthletes401
    | DashboardLeaguesControllerAthletes404
    | DashboardLeaguesControllerAthletes429
  >,
>(
  id: string,
  params?: DashboardLeaguesControllerAthletesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerAthletes>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardLeaguesControllerAthletesQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardLeaguesControllerAthletes>>> = ({
    signal,
  }) => dashboardLeaguesControllerAthletes(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerAthletes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeaguesControllerAthletesQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeaguesControllerAthletes>>
>;
export type DashboardLeaguesControllerAthletesQueryError = ErrorType<
  | DashboardLeaguesControllerAthletes400
  | DashboardLeaguesControllerAthletes401
  | DashboardLeaguesControllerAthletes404
  | DashboardLeaguesControllerAthletes429
>;

export function useDashboardLeaguesControllerAthletes<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerAthletes>>,
  TError = ErrorType<
    | DashboardLeaguesControllerAthletes400
    | DashboardLeaguesControllerAthletes401
    | DashboardLeaguesControllerAthletes404
    | DashboardLeaguesControllerAthletes429
  >,
>(
  id: string,
  params: undefined | DashboardLeaguesControllerAthletesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerAthletes>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerAthletes>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerAthletes<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerAthletes>>,
  TError = ErrorType<
    | DashboardLeaguesControllerAthletes400
    | DashboardLeaguesControllerAthletes401
    | DashboardLeaguesControllerAthletes404
    | DashboardLeaguesControllerAthletes429
  >,
>(
  id: string,
  params?: DashboardLeaguesControllerAthletesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerAthletes>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerAthletes>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerAthletes<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerAthletes>>,
  TError = ErrorType<
    | DashboardLeaguesControllerAthletes400
    | DashboardLeaguesControllerAthletes401
    | DashboardLeaguesControllerAthletes404
    | DashboardLeaguesControllerAthletes429
  >,
>(
  id: string,
  params?: DashboardLeaguesControllerAthletesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerAthletes>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List league athletes (dashboard)
 */

export function useDashboardLeaguesControllerAthletes<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerAthletes>>,
  TError = ErrorType<
    | DashboardLeaguesControllerAthletes400
    | DashboardLeaguesControllerAthletes401
    | DashboardLeaguesControllerAthletes404
    | DashboardLeaguesControllerAthletes429
  >,
>(
  id: string,
  params?: DashboardLeaguesControllerAthletesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerAthletes>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeaguesControllerAthletesQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Streamed CSV / XLSX export of a league's athletes with filter parity against `GET /leagues/:id/athletes`. No pagination; capped at 100k rows server-side (413 EXPORT_TOO_LARGE). Optional `columns` selects a subset of the fixed column set; omit for all. 404 when the league does not exist or is outside the caller's scope.
 * @summary Export league athletes (dashboard)
 */
export const dashboardLeaguesControllerAthletesExport = (
  id: string,
  params: DashboardLeaguesControllerAthletesExportParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<Blob>(
    {
      url: `/api/dashboard/v1/leagues/${id}/athletes/export`,
      method: "GET",
      params,
      responseType: "blob",
      signal,
    },
    options
  );
};

export const getDashboardLeaguesControllerAthletesExportQueryKey = (
  id: string,
  params: DashboardLeaguesControllerAthletesExportParams
) => {
  return [`/api/dashboard/v1/leagues/${id}/athletes/export`, ...(params ? [params] : [])] as const;
};

export const getDashboardLeaguesControllerAthletesExportQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerAthletesExport>>,
  TError = ErrorType<
    | DashboardLeaguesControllerAthletesExport400
    | DashboardLeaguesControllerAthletesExport401
    | DashboardLeaguesControllerAthletesExport404
    | DashboardLeaguesControllerAthletesExport413
    | DashboardLeaguesControllerAthletesExport429
  >,
>(
  id: string,
  params: DashboardLeaguesControllerAthletesExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerAthletesExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardLeaguesControllerAthletesExportQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardLeaguesControllerAthletesExport>>
  > = ({ signal }) => dashboardLeaguesControllerAthletesExport(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerAthletesExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeaguesControllerAthletesExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeaguesControllerAthletesExport>>
>;
export type DashboardLeaguesControllerAthletesExportQueryError = ErrorType<
  | DashboardLeaguesControllerAthletesExport400
  | DashboardLeaguesControllerAthletesExport401
  | DashboardLeaguesControllerAthletesExport404
  | DashboardLeaguesControllerAthletesExport413
  | DashboardLeaguesControllerAthletesExport429
>;

export function useDashboardLeaguesControllerAthletesExport<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerAthletesExport>>,
  TError = ErrorType<
    | DashboardLeaguesControllerAthletesExport400
    | DashboardLeaguesControllerAthletesExport401
    | DashboardLeaguesControllerAthletesExport404
    | DashboardLeaguesControllerAthletesExport413
    | DashboardLeaguesControllerAthletesExport429
  >,
>(
  id: string,
  params: DashboardLeaguesControllerAthletesExportParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerAthletesExport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerAthletesExport>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerAthletesExport<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerAthletesExport>>,
  TError = ErrorType<
    | DashboardLeaguesControllerAthletesExport400
    | DashboardLeaguesControllerAthletesExport401
    | DashboardLeaguesControllerAthletesExport404
    | DashboardLeaguesControllerAthletesExport413
    | DashboardLeaguesControllerAthletesExport429
  >,
>(
  id: string,
  params: DashboardLeaguesControllerAthletesExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerAthletesExport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerAthletesExport>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerAthletesExport<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerAthletesExport>>,
  TError = ErrorType<
    | DashboardLeaguesControllerAthletesExport400
    | DashboardLeaguesControllerAthletesExport401
    | DashboardLeaguesControllerAthletesExport404
    | DashboardLeaguesControllerAthletesExport413
    | DashboardLeaguesControllerAthletesExport429
  >,
>(
  id: string,
  params: DashboardLeaguesControllerAthletesExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerAthletesExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Export league athletes (dashboard)
 */

export function useDashboardLeaguesControllerAthletesExport<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerAthletesExport>>,
  TError = ErrorType<
    | DashboardLeaguesControllerAthletesExport400
    | DashboardLeaguesControllerAthletesExport401
    | DashboardLeaguesControllerAthletesExport404
    | DashboardLeaguesControllerAthletesExport413
    | DashboardLeaguesControllerAthletesExport429
  >,
>(
  id: string,
  params: DashboardLeaguesControllerAthletesExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerAthletesExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeaguesControllerAthletesExportQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Paginated list of the league's teams (teams with at least one confirmed tournament entry in the league), addressed by the league's `publicId` (`lge_…`). Filters: keyword (team title), sport ids, country, and the League Setup dimensions (season / region / level / custom tag). Each row carries the team's identity, logo, country, contact, sport, club, member count, and the count of distinct tournaments it has entered in this league. 404 when the league does not exist or is outside the caller's scope.
 * @summary List league teams (dashboard)
 */
export const dashboardLeaguesControllerTeams = (
  id: string,
  params?: DashboardLeaguesControllerTeamsParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLeagueTeamList>(
    { url: `/api/dashboard/v1/leagues/${id}/teams`, method: "GET", params, signal },
    options
  );
};

export const getDashboardLeaguesControllerTeamsQueryKey = (
  id: string,
  params?: DashboardLeaguesControllerTeamsParams
) => {
  return [`/api/dashboard/v1/leagues/${id}/teams`, ...(params ? [params] : [])] as const;
};

export const getDashboardLeaguesControllerTeamsQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerTeams>>,
  TError = ErrorType<
    | DashboardLeaguesControllerTeams400
    | DashboardLeaguesControllerTeams401
    | DashboardLeaguesControllerTeams404
    | DashboardLeaguesControllerTeams429
  >,
>(
  id: string,
  params?: DashboardLeaguesControllerTeamsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerTeams>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardLeaguesControllerTeamsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardLeaguesControllerTeams>>> = ({
    signal,
  }) => dashboardLeaguesControllerTeams(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerTeams>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeaguesControllerTeamsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeaguesControllerTeams>>
>;
export type DashboardLeaguesControllerTeamsQueryError = ErrorType<
  | DashboardLeaguesControllerTeams400
  | DashboardLeaguesControllerTeams401
  | DashboardLeaguesControllerTeams404
  | DashboardLeaguesControllerTeams429
>;

export function useDashboardLeaguesControllerTeams<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerTeams>>,
  TError = ErrorType<
    | DashboardLeaguesControllerTeams400
    | DashboardLeaguesControllerTeams401
    | DashboardLeaguesControllerTeams404
    | DashboardLeaguesControllerTeams429
  >,
>(
  id: string,
  params: undefined | DashboardLeaguesControllerTeamsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerTeams>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerTeams>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerTeams<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerTeams>>,
  TError = ErrorType<
    | DashboardLeaguesControllerTeams400
    | DashboardLeaguesControllerTeams401
    | DashboardLeaguesControllerTeams404
    | DashboardLeaguesControllerTeams429
  >,
>(
  id: string,
  params?: DashboardLeaguesControllerTeamsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerTeams>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerTeams>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerTeams<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerTeams>>,
  TError = ErrorType<
    | DashboardLeaguesControllerTeams400
    | DashboardLeaguesControllerTeams401
    | DashboardLeaguesControllerTeams404
    | DashboardLeaguesControllerTeams429
  >,
>(
  id: string,
  params?: DashboardLeaguesControllerTeamsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerTeams>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List league teams (dashboard)
 */

export function useDashboardLeaguesControllerTeams<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerTeams>>,
  TError = ErrorType<
    | DashboardLeaguesControllerTeams400
    | DashboardLeaguesControllerTeams401
    | DashboardLeaguesControllerTeams404
    | DashboardLeaguesControllerTeams429
  >,
>(
  id: string,
  params?: DashboardLeaguesControllerTeamsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerTeams>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeaguesControllerTeamsQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Streamed CSV / XLSX export of a league's teams with filter parity against `GET /leagues/:id/teams`. No pagination; capped at 100k rows server-side (413 EXPORT_TOO_LARGE). Optional `columns` selects a subset of the fixed column set; omit for all. 404 when the league does not exist or is outside the caller's scope.
 * @summary Export league teams (dashboard)
 */
export const dashboardLeaguesControllerTeamsExport = (
  id: string,
  params: DashboardLeaguesControllerTeamsExportParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<Blob>(
    {
      url: `/api/dashboard/v1/leagues/${id}/teams/export`,
      method: "GET",
      params,
      responseType: "blob",
      signal,
    },
    options
  );
};

export const getDashboardLeaguesControllerTeamsExportQueryKey = (
  id: string,
  params: DashboardLeaguesControllerTeamsExportParams
) => {
  return [`/api/dashboard/v1/leagues/${id}/teams/export`, ...(params ? [params] : [])] as const;
};

export const getDashboardLeaguesControllerTeamsExportQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerTeamsExport>>,
  TError = ErrorType<
    | DashboardLeaguesControllerTeamsExport400
    | DashboardLeaguesControllerTeamsExport401
    | DashboardLeaguesControllerTeamsExport404
    | DashboardLeaguesControllerTeamsExport413
    | DashboardLeaguesControllerTeamsExport429
  >,
>(
  id: string,
  params: DashboardLeaguesControllerTeamsExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerTeamsExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardLeaguesControllerTeamsExportQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardLeaguesControllerTeamsExport>>
  > = ({ signal }) => dashboardLeaguesControllerTeamsExport(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerTeamsExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeaguesControllerTeamsExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeaguesControllerTeamsExport>>
>;
export type DashboardLeaguesControllerTeamsExportQueryError = ErrorType<
  | DashboardLeaguesControllerTeamsExport400
  | DashboardLeaguesControllerTeamsExport401
  | DashboardLeaguesControllerTeamsExport404
  | DashboardLeaguesControllerTeamsExport413
  | DashboardLeaguesControllerTeamsExport429
>;

export function useDashboardLeaguesControllerTeamsExport<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerTeamsExport>>,
  TError = ErrorType<
    | DashboardLeaguesControllerTeamsExport400
    | DashboardLeaguesControllerTeamsExport401
    | DashboardLeaguesControllerTeamsExport404
    | DashboardLeaguesControllerTeamsExport413
    | DashboardLeaguesControllerTeamsExport429
  >,
>(
  id: string,
  params: DashboardLeaguesControllerTeamsExportParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerTeamsExport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerTeamsExport>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerTeamsExport<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerTeamsExport>>,
  TError = ErrorType<
    | DashboardLeaguesControllerTeamsExport400
    | DashboardLeaguesControllerTeamsExport401
    | DashboardLeaguesControllerTeamsExport404
    | DashboardLeaguesControllerTeamsExport413
    | DashboardLeaguesControllerTeamsExport429
  >,
>(
  id: string,
  params: DashboardLeaguesControllerTeamsExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerTeamsExport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerTeamsExport>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerTeamsExport<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerTeamsExport>>,
  TError = ErrorType<
    | DashboardLeaguesControllerTeamsExport400
    | DashboardLeaguesControllerTeamsExport401
    | DashboardLeaguesControllerTeamsExport404
    | DashboardLeaguesControllerTeamsExport413
    | DashboardLeaguesControllerTeamsExport429
  >,
>(
  id: string,
  params: DashboardLeaguesControllerTeamsExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerTeamsExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Export league teams (dashboard)
 */

export function useDashboardLeaguesControllerTeamsExport<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerTeamsExport>>,
  TError = ErrorType<
    | DashboardLeaguesControllerTeamsExport400
    | DashboardLeaguesControllerTeamsExport401
    | DashboardLeaguesControllerTeamsExport404
    | DashboardLeaguesControllerTeamsExport413
    | DashboardLeaguesControllerTeamsExport429
  >,
>(
  id: string,
  params: DashboardLeaguesControllerTeamsExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerTeamsExport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeaguesControllerTeamsExportQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The league's teams ordered by on-court activity, addressed by the league's `publicId` (`lge_…`). Requires `rankingCategoryId` (`rct_…`) — points for that ranking category are the 3rd sort key and the `points` field. Sort (`sortBy=activity`, the only strategy): distinct events DESC, matches played DESC, points DESC, id ASC. Each row carries the team's identity, logo, club, and its events / matches / points in this league. 404 when the league does not exist / is out of scope, or the ranking category is unknown / not attached to the league.
 * @summary List a league’s top teams by activity (dashboard)
 */
export const dashboardLeaguesControllerTopTeams = (
  id: string,
  params: DashboardLeaguesControllerTopTeamsParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLeagueTopTeamList>(
    { url: `/api/dashboard/v1/leagues/${id}/top-teams`, method: "GET", params, signal },
    options
  );
};

export const getDashboardLeaguesControllerTopTeamsQueryKey = (
  id: string,
  params: DashboardLeaguesControllerTopTeamsParams
) => {
  return [`/api/dashboard/v1/leagues/${id}/top-teams`, ...(params ? [params] : [])] as const;
};

export const getDashboardLeaguesControllerTopTeamsQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerTopTeams>>,
  TError = ErrorType<
    | DashboardLeaguesControllerTopTeams400
    | DashboardLeaguesControllerTopTeams401
    | DashboardLeaguesControllerTopTeams404
    | DashboardLeaguesControllerTopTeams429
  >,
>(
  id: string,
  params: DashboardLeaguesControllerTopTeamsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerTopTeams>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardLeaguesControllerTopTeamsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardLeaguesControllerTopTeams>>> = ({
    signal,
  }) => dashboardLeaguesControllerTopTeams(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerTopTeams>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeaguesControllerTopTeamsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeaguesControllerTopTeams>>
>;
export type DashboardLeaguesControllerTopTeamsQueryError = ErrorType<
  | DashboardLeaguesControllerTopTeams400
  | DashboardLeaguesControllerTopTeams401
  | DashboardLeaguesControllerTopTeams404
  | DashboardLeaguesControllerTopTeams429
>;

export function useDashboardLeaguesControllerTopTeams<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerTopTeams>>,
  TError = ErrorType<
    | DashboardLeaguesControllerTopTeams400
    | DashboardLeaguesControllerTopTeams401
    | DashboardLeaguesControllerTopTeams404
    | DashboardLeaguesControllerTopTeams429
  >,
>(
  id: string,
  params: DashboardLeaguesControllerTopTeamsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerTopTeams>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerTopTeams>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerTopTeams<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerTopTeams>>,
  TError = ErrorType<
    | DashboardLeaguesControllerTopTeams400
    | DashboardLeaguesControllerTopTeams401
    | DashboardLeaguesControllerTopTeams404
    | DashboardLeaguesControllerTopTeams429
  >,
>(
  id: string,
  params: DashboardLeaguesControllerTopTeamsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerTopTeams>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerTopTeams>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerTopTeams<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerTopTeams>>,
  TError = ErrorType<
    | DashboardLeaguesControllerTopTeams400
    | DashboardLeaguesControllerTopTeams401
    | DashboardLeaguesControllerTopTeams404
    | DashboardLeaguesControllerTopTeams429
  >,
>(
  id: string,
  params: DashboardLeaguesControllerTopTeamsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerTopTeams>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List a league’s top teams by activity (dashboard)
 */

export function useDashboardLeaguesControllerTopTeams<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerTopTeams>>,
  TError = ErrorType<
    | DashboardLeaguesControllerTopTeams400
    | DashboardLeaguesControllerTopTeams401
    | DashboardLeaguesControllerTopTeams404
    | DashboardLeaguesControllerTopTeams429
  >,
>(
  id: string,
  params: DashboardLeaguesControllerTopTeamsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerTopTeams>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeaguesControllerTopTeamsQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The league's athletes ordered by on-court activity, addressed by the league's `publicId` (`lge_…`). Requires `rankingCategoryId` (`rct_…`) — points for that ranking category are the 3rd sort key and the `points` field. Sort (`sortBy=activity`, the only strategy): distinct events DESC, matches played DESC, points DESC, id ASC. Each row carries the athlete's identity, avatar, clubs, and its events / matches / points in this league. 404 when the league does not exist / is out of scope, or the ranking category is unknown / not attached to the league.
 * @summary List a league’s top athletes by activity (dashboard)
 */
export const dashboardLeaguesControllerTopAthletes = (
  id: string,
  params: DashboardLeaguesControllerTopAthletesParams,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLeagueTopAthleteList>(
    { url: `/api/dashboard/v1/leagues/${id}/top-athletes`, method: "GET", params, signal },
    options
  );
};

export const getDashboardLeaguesControllerTopAthletesQueryKey = (
  id: string,
  params: DashboardLeaguesControllerTopAthletesParams
) => {
  return [`/api/dashboard/v1/leagues/${id}/top-athletes`, ...(params ? [params] : [])] as const;
};

export const getDashboardLeaguesControllerTopAthletesQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerTopAthletes>>,
  TError = ErrorType<
    | DashboardLeaguesControllerTopAthletes400
    | DashboardLeaguesControllerTopAthletes401
    | DashboardLeaguesControllerTopAthletes404
    | DashboardLeaguesControllerTopAthletes429
  >,
>(
  id: string,
  params: DashboardLeaguesControllerTopAthletesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerTopAthletes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardLeaguesControllerTopAthletesQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardLeaguesControllerTopAthletes>>
  > = ({ signal }) => dashboardLeaguesControllerTopAthletes(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerTopAthletes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeaguesControllerTopAthletesQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeaguesControllerTopAthletes>>
>;
export type DashboardLeaguesControllerTopAthletesQueryError = ErrorType<
  | DashboardLeaguesControllerTopAthletes400
  | DashboardLeaguesControllerTopAthletes401
  | DashboardLeaguesControllerTopAthletes404
  | DashboardLeaguesControllerTopAthletes429
>;

export function useDashboardLeaguesControllerTopAthletes<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerTopAthletes>>,
  TError = ErrorType<
    | DashboardLeaguesControllerTopAthletes400
    | DashboardLeaguesControllerTopAthletes401
    | DashboardLeaguesControllerTopAthletes404
    | DashboardLeaguesControllerTopAthletes429
  >,
>(
  id: string,
  params: DashboardLeaguesControllerTopAthletesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerTopAthletes>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerTopAthletes>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerTopAthletes<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerTopAthletes>>,
  TError = ErrorType<
    | DashboardLeaguesControllerTopAthletes400
    | DashboardLeaguesControllerTopAthletes401
    | DashboardLeaguesControllerTopAthletes404
    | DashboardLeaguesControllerTopAthletes429
  >,
>(
  id: string,
  params: DashboardLeaguesControllerTopAthletesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerTopAthletes>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerTopAthletes>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerTopAthletes<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerTopAthletes>>,
  TError = ErrorType<
    | DashboardLeaguesControllerTopAthletes400
    | DashboardLeaguesControllerTopAthletes401
    | DashboardLeaguesControllerTopAthletes404
    | DashboardLeaguesControllerTopAthletes429
  >,
>(
  id: string,
  params: DashboardLeaguesControllerTopAthletesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerTopAthletes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List a league’s top athletes by activity (dashboard)
 */

export function useDashboardLeaguesControllerTopAthletes<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerTopAthletes>>,
  TError = ErrorType<
    | DashboardLeaguesControllerTopAthletes400
    | DashboardLeaguesControllerTopAthletes401
    | DashboardLeaguesControllerTopAthletes404
    | DashboardLeaguesControllerTopAthletes429
  >,
>(
  id: string,
  params: DashboardLeaguesControllerTopAthletesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerTopAthletes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeaguesControllerTopAthletesQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * A team's roster with demographics and the values for the LEAGUE's enabled rating systems, for the admin "Team members" modal. The league (`lge_…`) drives the access gate (same scope as the league detail route) and selects which rating systems (`ratingSystems[]`) are returned; each member exposes exactly those systems under `ratings`. Ranking / position is intentionally omitted. 404 when the league does not exist / is out of scope, or the team does not exist.
 * @summary List a team’s members with league rating systems (dashboard)
 */
export const dashboardLeaguesControllerTeamMembers = (
  id: string,
  teamId: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLeagueTeamMembers>(
    { url: `/api/dashboard/v1/leagues/${id}/teams/${teamId}/members`, method: "GET", signal },
    options
  );
};

export const getDashboardLeaguesControllerTeamMembersQueryKey = (id: string, teamId: string) => {
  return [`/api/dashboard/v1/leagues/${id}/teams/${teamId}/members`] as const;
};

export const getDashboardLeaguesControllerTeamMembersQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerTeamMembers>>,
  TError = ErrorType<
    | DashboardLeaguesControllerTeamMembers400
    | DashboardLeaguesControllerTeamMembers401
    | DashboardLeaguesControllerTeamMembers404
    | DashboardLeaguesControllerTeamMembers429
  >,
>(
  id: string,
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerTeamMembers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDashboardLeaguesControllerTeamMembersQueryKey(id, teamId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardLeaguesControllerTeamMembers>>
  > = ({ signal }) => dashboardLeaguesControllerTeamMembers(id, teamId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(id && teamId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerTeamMembers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeaguesControllerTeamMembersQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeaguesControllerTeamMembers>>
>;
export type DashboardLeaguesControllerTeamMembersQueryError = ErrorType<
  | DashboardLeaguesControllerTeamMembers400
  | DashboardLeaguesControllerTeamMembers401
  | DashboardLeaguesControllerTeamMembers404
  | DashboardLeaguesControllerTeamMembers429
>;

export function useDashboardLeaguesControllerTeamMembers<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerTeamMembers>>,
  TError = ErrorType<
    | DashboardLeaguesControllerTeamMembers400
    | DashboardLeaguesControllerTeamMembers401
    | DashboardLeaguesControllerTeamMembers404
    | DashboardLeaguesControllerTeamMembers429
  >,
>(
  id: string,
  teamId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerTeamMembers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerTeamMembers>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerTeamMembers<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerTeamMembers>>,
  TError = ErrorType<
    | DashboardLeaguesControllerTeamMembers400
    | DashboardLeaguesControllerTeamMembers401
    | DashboardLeaguesControllerTeamMembers404
    | DashboardLeaguesControllerTeamMembers429
  >,
>(
  id: string,
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerTeamMembers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerTeamMembers>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerTeamMembers<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerTeamMembers>>,
  TError = ErrorType<
    | DashboardLeaguesControllerTeamMembers400
    | DashboardLeaguesControllerTeamMembers401
    | DashboardLeaguesControllerTeamMembers404
    | DashboardLeaguesControllerTeamMembers429
  >,
>(
  id: string,
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerTeamMembers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List a team’s members with league rating systems (dashboard)
 */

export function useDashboardLeaguesControllerTeamMembers<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerTeamMembers>>,
  TError = ErrorType<
    | DashboardLeaguesControllerTeamMembers400
    | DashboardLeaguesControllerTeamMembers401
    | DashboardLeaguesControllerTeamMembers404
    | DashboardLeaguesControllerTeamMembers429
  >,
>(
  id: string,
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerTeamMembers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeaguesControllerTeamMembersQueryOptions(id, teamId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The sports a league covers, addressed by the league's `publicId` (`lge_…`). Feeds the tournament-category sport picker, whose options are limited to the parent league's sports. Same auth/scope as the league detail route. Empty array when the league has no sports attached. 404 when the league does not exist or is outside the caller's scope.
 * @summary List a league’s sports (dashboard)
 */
export const dashboardLeaguesControllerSports = (
  id: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardSportRef[]>(
    { url: `/api/dashboard/v1/leagues/${id}/sports`, method: "GET", signal },
    options
  );
};

export const getDashboardLeaguesControllerSportsQueryKey = (id: string) => {
  return [`/api/dashboard/v1/leagues/${id}/sports`] as const;
};

export const getDashboardLeaguesControllerSportsQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerSports>>,
  TError = ErrorType<
    | DashboardLeaguesControllerSports400
    | DashboardLeaguesControllerSports401
    | DashboardLeaguesControllerSports404
    | DashboardLeaguesControllerSports429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerSports>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardLeaguesControllerSportsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardLeaguesControllerSports>>> = ({
    signal,
  }) => dashboardLeaguesControllerSports(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerSports>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeaguesControllerSportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeaguesControllerSports>>
>;
export type DashboardLeaguesControllerSportsQueryError = ErrorType<
  | DashboardLeaguesControllerSports400
  | DashboardLeaguesControllerSports401
  | DashboardLeaguesControllerSports404
  | DashboardLeaguesControllerSports429
>;

export function useDashboardLeaguesControllerSports<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerSports>>,
  TError = ErrorType<
    | DashboardLeaguesControllerSports400
    | DashboardLeaguesControllerSports401
    | DashboardLeaguesControllerSports404
    | DashboardLeaguesControllerSports429
  >,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerSports>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerSports>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerSports<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerSports>>,
  TError = ErrorType<
    | DashboardLeaguesControllerSports400
    | DashboardLeaguesControllerSports401
    | DashboardLeaguesControllerSports404
    | DashboardLeaguesControllerSports429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerSports>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerSports>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerSports<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerSports>>,
  TError = ErrorType<
    | DashboardLeaguesControllerSports400
    | DashboardLeaguesControllerSports401
    | DashboardLeaguesControllerSports404
    | DashboardLeaguesControllerSports429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerSports>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List a league’s sports (dashboard)
 */

export function useDashboardLeaguesControllerSports<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerSports>>,
  TError = ErrorType<
    | DashboardLeaguesControllerSports400
    | DashboardLeaguesControllerSports401
    | DashboardLeaguesControllerSports404
    | DashboardLeaguesControllerSports429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerSports>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeaguesControllerSportsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The league setup checklist for the league addressed by its `publicId` (`lge_…`): every onboarding step in canonical guide order, each flagged completed or not (with the completion timestamp). Unlike the user-level `GET /onboarding`, these steps are toggled manually by a league manager. Access is limited to the league's accessible set (league managers + federation owners/managers; admin/superAdmin bypass). 404 when the league does not exist; 403 when the caller cannot reach it.
 * @summary Get league onboarding steps (dashboard)
 */
export const dashboardLeaguesControllerOnboarding = (
  id: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLeagueOnboardingStep[]>(
    { url: `/api/dashboard/v1/leagues/${id}/onboarding`, method: "GET", signal },
    options
  );
};

export const getDashboardLeaguesControllerOnboardingQueryKey = (id: string) => {
  return [`/api/dashboard/v1/leagues/${id}/onboarding`] as const;
};

export const getDashboardLeaguesControllerOnboardingQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerOnboarding>>,
  TError = ErrorType<
    | DashboardLeaguesControllerOnboarding400
    | DashboardLeaguesControllerOnboarding401
    | DashboardLeaguesControllerOnboarding403
    | DashboardLeaguesControllerOnboarding404
    | DashboardLeaguesControllerOnboarding429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerOnboarding>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardLeaguesControllerOnboardingQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardLeaguesControllerOnboarding>>
  > = ({ signal }) => dashboardLeaguesControllerOnboarding(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerOnboarding>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeaguesControllerOnboardingQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeaguesControllerOnboarding>>
>;
export type DashboardLeaguesControllerOnboardingQueryError = ErrorType<
  | DashboardLeaguesControllerOnboarding400
  | DashboardLeaguesControllerOnboarding401
  | DashboardLeaguesControllerOnboarding403
  | DashboardLeaguesControllerOnboarding404
  | DashboardLeaguesControllerOnboarding429
>;

export function useDashboardLeaguesControllerOnboarding<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerOnboarding>>,
  TError = ErrorType<
    | DashboardLeaguesControllerOnboarding400
    | DashboardLeaguesControllerOnboarding401
    | DashboardLeaguesControllerOnboarding403
    | DashboardLeaguesControllerOnboarding404
    | DashboardLeaguesControllerOnboarding429
  >,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerOnboarding>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerOnboarding>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerOnboarding<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerOnboarding>>,
  TError = ErrorType<
    | DashboardLeaguesControllerOnboarding400
    | DashboardLeaguesControllerOnboarding401
    | DashboardLeaguesControllerOnboarding403
    | DashboardLeaguesControllerOnboarding404
    | DashboardLeaguesControllerOnboarding429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerOnboarding>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerOnboarding>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerOnboarding<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerOnboarding>>,
  TError = ErrorType<
    | DashboardLeaguesControllerOnboarding400
    | DashboardLeaguesControllerOnboarding401
    | DashboardLeaguesControllerOnboarding403
    | DashboardLeaguesControllerOnboarding404
    | DashboardLeaguesControllerOnboarding429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerOnboarding>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get league onboarding steps (dashboard)
 */

export function useDashboardLeaguesControllerOnboarding<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerOnboarding>>,
  TError = ErrorType<
    | DashboardLeaguesControllerOnboarding400
    | DashboardLeaguesControllerOnboarding401
    | DashboardLeaguesControllerOnboarding403
    | DashboardLeaguesControllerOnboarding404
    | DashboardLeaguesControllerOnboarding429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof dashboardLeaguesControllerOnboarding>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeaguesControllerOnboardingQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Mark a single onboarding `step` complete (`isCompleted: true`, idempotent) or re-open it (`false`) for the league addressed by its `publicId` (`lge_…`). Only league managers (the accessible-league set: league managers + federation owners/managers; admin/superAdmin bypass) may toggle. Returns the full step list in canonical guide order so the FE can swap its state without a re-fetch. 404 when the league or step is unknown; 403 when the caller cannot manage the league.
 * @summary Toggle a league onboarding step (dashboard)
 */
export const dashboardLeaguesControllerUpdateOnboardingStep = (
  id: string,
  step: string,
  dashboardLeagueOnboardingUpdate: BodyType<DashboardLeagueOnboardingUpdate>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<DashboardLeagueOnboardingStep[]>(
    {
      url: `/api/dashboard/v1/leagues/${id}/onboarding/${step}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardLeagueOnboardingUpdate,
    },
    options
  );
};

export const getDashboardLeaguesControllerUpdateOnboardingStepMutationOptions = <
  TError = ErrorType<
    | DashboardLeaguesControllerUpdateOnboardingStep400
    | DashboardLeaguesControllerUpdateOnboardingStep401
    | DashboardLeaguesControllerUpdateOnboardingStep403
    | DashboardLeaguesControllerUpdateOnboardingStep404
    | DashboardLeaguesControllerUpdateOnboardingStep429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerUpdateOnboardingStep>>,
    TError,
    { id: string; step: string; data: BodyType<DashboardLeagueOnboardingUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeaguesControllerUpdateOnboardingStep>>,
  TError,
  { id: string; step: string; data: BodyType<DashboardLeagueOnboardingUpdate> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeaguesControllerUpdateOnboardingStep>>,
    { id: string; step: string; data: BodyType<DashboardLeagueOnboardingUpdate> }
  > = (props) => {
    const { id, step, data } = props ?? {};

    return dashboardLeaguesControllerUpdateOnboardingStep(id, step, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeaguesControllerUpdateOnboardingStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeaguesControllerUpdateOnboardingStep>>
>;
export type DashboardLeaguesControllerUpdateOnboardingStepMutationBody =
  BodyType<DashboardLeagueOnboardingUpdate>;
export type DashboardLeaguesControllerUpdateOnboardingStepMutationError = ErrorType<
  | DashboardLeaguesControllerUpdateOnboardingStep400
  | DashboardLeaguesControllerUpdateOnboardingStep401
  | DashboardLeaguesControllerUpdateOnboardingStep403
  | DashboardLeaguesControllerUpdateOnboardingStep404
  | DashboardLeaguesControllerUpdateOnboardingStep429
>;

/**
 * @summary Toggle a league onboarding step (dashboard)
 */
export const useDashboardLeaguesControllerUpdateOnboardingStep = <
  TError = ErrorType<
    | DashboardLeaguesControllerUpdateOnboardingStep400
    | DashboardLeaguesControllerUpdateOnboardingStep401
    | DashboardLeaguesControllerUpdateOnboardingStep403
    | DashboardLeaguesControllerUpdateOnboardingStep404
    | DashboardLeaguesControllerUpdateOnboardingStep429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerUpdateOnboardingStep>>,
    TError,
    { id: string; step: string; data: BodyType<DashboardLeagueOnboardingUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeaguesControllerUpdateOnboardingStep>>,
  TError,
  { id: string; step: string; data: BodyType<DashboardLeagueOnboardingUpdate> },
  TContext
> => {
  const mutationOptions = getDashboardLeaguesControllerUpdateOnboardingStepMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Mark every onboarding step complete in one call for the league addressed by its `publicId` (`lge_…`) — the "Skip all" action. Idempotent: steps already done keep their original completion. Only league managers (the accessible-league set: league managers + federation owners/managers; admin/superAdmin bypass) may skip. Returns the full step list in canonical guide order so the FE can swap its state without a re-fetch. 404 when the league is unknown; 403 when the caller cannot manage the league.
 * @summary Skip all league onboarding steps (dashboard)
 */
export const dashboardLeaguesControllerSkipAllOnboarding = (
  id: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLeagueOnboardingStep[]>(
    { url: `/api/dashboard/v1/leagues/${id}/onboarding/skip-all`, method: "POST", signal },
    options
  );
};

export const getDashboardLeaguesControllerSkipAllOnboardingMutationOptions = <
  TError = ErrorType<
    | DashboardLeaguesControllerSkipAllOnboarding400
    | DashboardLeaguesControllerSkipAllOnboarding401
    | DashboardLeaguesControllerSkipAllOnboarding403
    | DashboardLeaguesControllerSkipAllOnboarding404
    | DashboardLeaguesControllerSkipAllOnboarding429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerSkipAllOnboarding>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeaguesControllerSkipAllOnboarding>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeaguesControllerSkipAllOnboarding>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return dashboardLeaguesControllerSkipAllOnboarding(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeaguesControllerSkipAllOnboardingMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeaguesControllerSkipAllOnboarding>>
>;

export type DashboardLeaguesControllerSkipAllOnboardingMutationError = ErrorType<
  | DashboardLeaguesControllerSkipAllOnboarding400
  | DashboardLeaguesControllerSkipAllOnboarding401
  | DashboardLeaguesControllerSkipAllOnboarding403
  | DashboardLeaguesControllerSkipAllOnboarding404
  | DashboardLeaguesControllerSkipAllOnboarding429
>;

/**
 * @summary Skip all league onboarding steps (dashboard)
 */
export const useDashboardLeaguesControllerSkipAllOnboarding = <
  TError = ErrorType<
    | DashboardLeaguesControllerSkipAllOnboarding400
    | DashboardLeaguesControllerSkipAllOnboarding401
    | DashboardLeaguesControllerSkipAllOnboarding403
    | DashboardLeaguesControllerSkipAllOnboarding404
    | DashboardLeaguesControllerSkipAllOnboarding429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerSkipAllOnboarding>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeaguesControllerSkipAllOnboarding>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDashboardLeaguesControllerSkipAllOnboardingMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Slim league detail for the dashboard edit page, addressed by the league's `publicId` (`lge_…`). Returns the form-facing editable field subset (identity, geo scope, sport / discipline, assets, contact, social links, flags, category cap), connected `clubs`, plus the read-only ownership refs (`owner` federation and accessible `platforms`). This is the *edit-form* detail; the richer overview-page aggregate lives at `:id/overview`. The fee tab (`customFees` + `isCustomFeeEnable`) is capability-dependent: it is only populated for callers holding `LEAGUE_FEE:READ` on the league; everyone else receives `customFees: []` / `isCustomFeeEnable: false` while the rest of the detail stays readable. 404 when the league does not exist or is outside the caller's scope.

Includes `capabilities` — the full RBAC capability set the caller holds on this league's LEAGUE node — so the edit page can gate its tabs and save controls without a follow-up request.
 * @summary Get league detail (dashboard)
 */
export const dashboardLeaguesControllerDetail = (
  id: string,
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardLeagueDetail>(
    { url: `/api/dashboard/v1/leagues/${id}`, method: "GET", signal },
    options
  );
};

export const getDashboardLeaguesControllerDetailQueryKey = (id: string) => {
  return [`/api/dashboard/v1/leagues/${id}`] as const;
};

export const getDashboardLeaguesControllerDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerDetail>>,
  TError = ErrorType<
    | DashboardLeaguesControllerDetail400
    | DashboardLeaguesControllerDetail401
    | DashboardLeaguesControllerDetail404
    | DashboardLeaguesControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardLeaguesControllerDetailQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboardLeaguesControllerDetail>>> = ({
    signal,
  }) => dashboardLeaguesControllerDetail(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardLeaguesControllerDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeaguesControllerDetail>>
>;
export type DashboardLeaguesControllerDetailQueryError = ErrorType<
  | DashboardLeaguesControllerDetail400
  | DashboardLeaguesControllerDetail401
  | DashboardLeaguesControllerDetail404
  | DashboardLeaguesControllerDetail429
>;

export function useDashboardLeaguesControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerDetail>>,
  TError = ErrorType<
    | DashboardLeaguesControllerDetail400
    | DashboardLeaguesControllerDetail401
    | DashboardLeaguesControllerDetail404
    | DashboardLeaguesControllerDetail429
  >,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerDetail>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerDetail>>,
  TError = ErrorType<
    | DashboardLeaguesControllerDetail400
    | DashboardLeaguesControllerDetail401
    | DashboardLeaguesControllerDetail404
    | DashboardLeaguesControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerDetail>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboardLeaguesControllerDetail>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardLeaguesControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerDetail>>,
  TError = ErrorType<
    | DashboardLeaguesControllerDetail400
    | DashboardLeaguesControllerDetail401
    | DashboardLeaguesControllerDetail404
    | DashboardLeaguesControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get league detail (dashboard)
 */

export function useDashboardLeaguesControllerDetail<
  TData = Awaited<ReturnType<typeof dashboardLeaguesControllerDetail>>,
  TError = ErrorType<
    | DashboardLeaguesControllerDetail400
    | DashboardLeaguesControllerDetail401
    | DashboardLeaguesControllerDetail404
    | DashboardLeaguesControllerDetail429
  >,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboardLeaguesControllerDetail>>, TError, TData>
    >;
    request?: SecondParameter<typeof restClient>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardLeaguesControllerDetailQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Partial update of an existing league addressed by its `publicId` (`lge_…`). Accepts the full editable field set (identity, geo scope, sport / discipline, uploaded assets via `*FileId`, contact, social links, flags, category cap, status) — reassigning the owning platform / federation is out of scope. `clubIds` whole-set replaces the visual Manager-display club connections (`[]` clears, omitted preserves); every submitted club additionally requires pair-aware `CLUB:WRITE`, and the association grants no permissions. Absent fields are left untouched; an explicit `null` clears a nullable field. Editing the league's own fees (`customFees`) additionally requires the `LEAGUE_FEE:WRITE` capability on the league (base `LEAGUE:WRITE` covers every other field); callers lacking it receive 403. Fee rows are cross-validated: every amount must be non-negative and each min tier must not exceed its max (400 `FEE_RANGE_INVALID`), and each row's currency must be one of the owning platform's configured currencies (400 `FEE_CURRENCY_NOT_ALLOWED`; a platform with no configured currencies is unrestricted). Out-of-scope ids surface as 404 so existence isn't probable across tenant boundaries. Returns the updated row in the same shape as `GET /api/dashboard/v1/leagues` so the FE can swap the table row without re-fetching the page.
 * @summary Update league (dashboard)
 */
export const dashboardLeaguesControllerUpdate = (
  id: string,
  dashboardUpdateLeague: BodyType<DashboardUpdateLeague>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<DashboardLeagueListItem>(
    {
      url: `/api/dashboard/v1/leagues/${id}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardUpdateLeague,
    },
    options
  );
};

export const getDashboardLeaguesControllerUpdateMutationOptions = <
  TError = ErrorType<
    | DashboardLeaguesControllerUpdate400
    | DashboardLeaguesControllerUpdate401
    | DashboardLeaguesControllerUpdate403
    | DashboardLeaguesControllerUpdate404
    | DashboardLeaguesControllerUpdate409
    | DashboardLeaguesControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerUpdate>>,
    TError,
    { id: string; data: BodyType<DashboardUpdateLeague> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardLeaguesControllerUpdate>>,
  TError,
  { id: string; data: BodyType<DashboardUpdateLeague> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardLeaguesControllerUpdate>>,
    { id: string; data: BodyType<DashboardUpdateLeague> }
  > = (props) => {
    const { id, data } = props ?? {};

    return dashboardLeaguesControllerUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardLeaguesControllerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardLeaguesControllerUpdate>>
>;
export type DashboardLeaguesControllerUpdateMutationBody = BodyType<DashboardUpdateLeague>;
export type DashboardLeaguesControllerUpdateMutationError = ErrorType<
  | DashboardLeaguesControllerUpdate400
  | DashboardLeaguesControllerUpdate401
  | DashboardLeaguesControllerUpdate403
  | DashboardLeaguesControllerUpdate404
  | DashboardLeaguesControllerUpdate409
  | DashboardLeaguesControllerUpdate429
>;

/**
 * @summary Update league (dashboard)
 */
export const useDashboardLeaguesControllerUpdate = <
  TError = ErrorType<
    | DashboardLeaguesControllerUpdate400
    | DashboardLeaguesControllerUpdate401
    | DashboardLeaguesControllerUpdate403
    | DashboardLeaguesControllerUpdate404
    | DashboardLeaguesControllerUpdate409
    | DashboardLeaguesControllerUpdate429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardLeaguesControllerUpdate>>,
    TError,
    { id: string; data: BodyType<DashboardUpdateLeague> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardLeaguesControllerUpdate>>,
  TError,
  { id: string; data: BodyType<DashboardUpdateLeague> },
  TContext
> => {
  const mutationOptions = getDashboardLeaguesControllerUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
